import { endMailSearchSession } from '../actions/publicActions';
import { getMailSearchStore } from '../store/Store';
import { orchestrator } from 'satcheljs';
import { selectFolder } from 'mini-mail-folder-actions';
import { setLastSelectedMailFolderId } from '../actions/privateActions';

/**
 * Orchestrator function to reset mail store to select the last selected folder
 * This is called only once, when the search module gets unmounted
 */
export default orchestrator(endMailSearchSession, () => {
    const { lastSelectedMailFolderId } = getMailSearchStore();

    /**
     * If there exists a lastSelectedMailFolderId then fire selectFolder so that the correct
     * TableView in set in the list store
     */
    lastSelectedMailFolderId && selectFolder(lastSelectedMailFolderId);

    // Reset the lastSelectedMailFolderId value in searchStore
    setLastSelectedMailFolderId(null);
});
